export default {
  catalog_id_placeholder: '№ ',
  country: 'Country',
  region: 'Region',
  city: 'City',
  district: 'District',
  category: 'Category',
  type: 'Type',
  subtype: 'Subtype',
  purpose: 'Deal type',
  any: 'Any',
  apply: 'Apply',
  reset: 'Reset',
  show: 'Show filter',
  hide: 'Hide filter',

  purpose_options: {
    sale: 'Sale',
    rental: 'Long-term rent',
    daily_rent: 'Short-term rent',
    investment: 'Investment',
    holiday: 'Holiday / Vacation',
    commercial_use: 'Commercial use',
    residence: 'Residential use'
  }
}
